window._ = require('lodash');
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.$ = window.jQuery = require('jquery/dist/jquery.min');
var jQueryBridget = require('jquery-bridget');
var imagesLoaded = require('./lib/imagesloaded.pkgd');
var fitVids = require('./lib/jquery.fitvids');
require('./lib/jquery.easing.1.3.js');

var Isotope = require('./lib/isotope.pkgd.js');
jQueryBridget( 'isotope', Isotope, $ );

var Smartmenus = require('./lib/jquery.smartmenus.min.js');
jQueryBridget( 'smartmenus', Smartmenus, $ );

require('./lib/jquery.prettyPhoto.js');

var justifiedGallery = require('./lib/jquery.justifiedGallery.min.js');
require('./lib/main.js');



